import React, {
    useContext,
    useMemo,
    useCallback
} from 'react';
import { Link } from '@jutro/components';
import { SG_AA_PREMIUM_PAGE_ACTION } from 'sg-adobe-analytics/AdobeAnalyticsConstants';
import { renderContentFromMetadata } from '@jutro/uiconfig';
import { TranslatorContext } from '@jutro/locale';
import { CepConstants } from 'saga-cep-specific-components';
import { useHistory } from 'react-router-dom';
import SpmConstants from 'sg-spm-constants';
import SgCepSideMenu from 'sg-cep-side-menu';
import { useSgTrackPageName, SgCepChanges } from 'saga-modules';
import { ViewModelServiceContext } from 'gw-portals-viewmodel-react';
import SgCoverEndorsements from 'sg-cover-endorsements';
import SgDeclarationsDocuments from 'sg-declarations-documents';
import SgImportantStatementsAndDeclarations from 'sg-important-statements-and-declarations';
import SgSpmDeclarationsBullets from 'sg-spm-declarations-bullets';
import _ from 'lodash';
import htmlParser from 'html-react-parser';
import { WizardPage } from 'gw-portals-wizard-react';
import metadata from './SgEndorsementDeclarationsPage.metadata.json5';
import messages from './SgEndorsementDeclarationsPage.messages';

function SgEndorsementDeclarationsPage(props) {
    const {
        wizardData: modelVM,
        goNext
    } = props;

    const history = useHistory();

    const handleCancel = useCallback(() => {
        history.goBack();
    }, [history]);

    const translator = useContext(TranslatorContext);
    const viewModelService = useContext(ViewModelServiceContext);

    const getValue = useCallback((value) => {
        const typelistValue = viewModelService.productMetadata.get('pc').types.getTypelist(value.typelist.name).getCode(value.code).name;
        return translator({ id: typelistValue, defaultMessage: typelistValue }).toString();
    }, [translator, viewModelService.productMetadata]);

    const changes = useMemo(() => {
        return SgCepChanges.getMotorChanges(modelVM, getValue);
    }, [modelVM, SgCepChanges.getMotorChanges, getValue]);

    useSgTrackPageName(CepConstants.PAGE_NAMES.STATEMENTS);

    const areAddonsOrEndorsementsAdded = useMemo(() => {
        return changes.coverageAdded;
    }, [changes]);

    const ifBreakdownCoverIsBeingAdded = useMemo(() => {
        if (!_.isNil(changes.coverageAdded)) {
            return !_.isNil(changes.coverageAdded.find((el) => el.publicID === SpmConstants.BREAKDOWN_CODE));
        }
        return false;
    }, [changes.coverageAdded]);

    const lobDocuments = useMemo(() => {
        return (
            <li>
                <Link
                    id="breakdownPolicyBookLink"
                    href={SpmConstants.POLICY_DOCUMENTS_LINKS.CAR_BREAKDOWN_BOOKLET}
                    target="_blank"
                    adobeValue={`${SG_AA_PREMIUM_PAGE_ACTION.LEVEL_1.DECLARATIONS}|${SG_AA_PREMIUM_PAGE_ACTION.LEVEL_2.TEXT}|
                        ${SG_AA_PREMIUM_PAGE_ACTION.LEVEL_3.BREAKDOWN_POLICY_BOOKLET}`}
                >
                    {translator(messages.EndorsementPageBreakdownAssistance)}
                </Link>
            </li>
        );
    }, [translator]);

    const overrideProps = {
        declarationsDocumentsSectionOnlyAccepting: {
            importantInfoLink: SpmConstants.IMPORTANT_INFORMATION_LINK,
            lobDocuments: null,
        },
        declarationsDocumentsSection: {
            importantInfoLink: SpmConstants.IMPORTANT_INFORMATION_LINK,
            lobDocuments: ifBreakdownCoverIsBeingAdded ? lobDocuments : null,
            isBullets: true
        },
        coverEndorsementsSection: {
            visible: areAddonsOrEndorsementsAdded,
            quoteEndorsements: modelVM.value.quoteEndorsements
        },
        declarationPageImportantAccept: {
            content: htmlParser(translator(messages.EndorsementPageImportantAccept))
        },
        continueButton: {
            onClick: goNext
        },
        importantStatementsAndDeclarations: {
            modelVM,
            showFullStatements: false,
            premium: { amount: 0 },
            isMonthly: false,
            lobBulletPoints: <SgSpmDeclarationsBullets />,
            isShortFormat: true,
            sagaPlusPolicyBook: SpmConstants.POLICY_DOCUMENTS_LINKS.POLICY_BOOKLET_SELECT_PLUS
        }
    };

    const resolvers = {
        resolveCallbackMap: {
            handleCancel
        },
        resolveComponentMap: {
            SgCoverEndorsements,
            SgDeclarationsDocuments,
            SgImportantStatementsAndDeclarations,
            SgCepSideMenu
        }
    };

    return (
        <WizardPage showPrevious={false} showNext={false}>
            {renderContentFromMetadata(metadata.pageContent, overrideProps, resolvers)}
        </WizardPage>
    );
}

export default SgEndorsementDeclarationsPage;
